import { render } from "./TriadSelectComponent.vue?vue&type=template&id=2a4c117a&scoped=true"
import script from "./TriadSelectComponent.vue?vue&type=script&lang=js"
export * from "./TriadSelectComponent.vue?vue&type=script&lang=js"

import "./TriadSelectComponent.vue?vue&type=style&index=0&id=2a4c117a&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a4c117a"]])

export default __exports__